export const truncator = (str: string, length: number) => {
  return str?.length > length ? str?.substring(0, length) + "..." : str;
};

export const midTruncator = (str: string, length: number) => {
  if (str?.length > length) {
    const start = Math.floor(length / 2);
    const end = str?.length - start;
    return str?.substring(0, start) + "..." + str.substring(end);
  }
  return str;
};
